import { Box } from '@material-ui/core';
import { CSSProperties, PropsWithChildren } from 'react';

export interface IPageInnerProps {
  height: string

  width?: string
  style?: CSSProperties
  bottomPadding?: string
}

export const PageInner = ({
  width,
  height,
  style,
  children,
  bottomPadding,
}: PropsWithChildren<IPageInnerProps>) => {
  return (
    <Box width={width || '100%'} height={height} style={style}>
      {children}
      <Box height={bottomPadding || "90px"} />
    </Box>
  )
}